import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftcardImageService } from '../../services/giftcard-image.service';
import {AppStateService} from '../../services/app-state.service';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';

@Component({
  selector: 'app-giftcard-preview',
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent],
  template: `
    <div class="relative min-h-[150px]">
      <img
        *ngIf="previewUrl"
        [src]="previewUrl"
        alt="Gift Card Preview"
        class="w-full rounded-lg shadow-md"
        [class.opacity-50]="isLoading"
        (load)="onImageLoad()"
        (error)="onImageError()"
      />
      <div *ngIf="isLoading" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
        <app-loading-spinner></app-loading-spinner>
      </div>
      <div *ngIf="errorMessage" class="text-red-500 mt-2 text-sm">
        {{ errorMessage }}
      </div>
    </div>
  `,
  styles: []
})
export class GiftcardPreviewComponent implements OnChanges {
  @Input() templateId: string = '';
  @Input() senderName: string = '';
  @Input() receiverName: string = '';
  @Input() message: string = '';
  @Input() amount: number = 100

  previewUrl: string | null = null;
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor(private giftcardImageService: GiftcardImageService, private appState: AppStateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.updatePreview();
  }

  private hasRequiredInputs(): boolean {
    return !!this.templateId &&
           !!this.senderName &&
           !!this.receiverName;
  }

  private updatePreview(): void {
    this.isLoading = true;
    this.errorMessage = null;

    try {
      this.previewUrl = this.giftcardImageService.getGiftcardPreviewUrl(
        this.templateId,
        this.senderName,
        this.receiverName,
        this.message || '',
        this.amount.toString(),
        this.appState.snapshot!.cfg.name,
          this.appState.snapshot!.venueId,
      );
      // Note: isLoading remains true until the image loads or errors out
    } catch (error) {
      this.errorMessage = 'Could not generate preview URL';
      this.previewUrl = null;
      this.isLoading = false;
    }
  }

  /**
   * Handle image load event
   */
  onImageLoad(): void {
    console.log('Giftcard preview image loaded');
    this.isLoading = false;
  }

  /**
   * Handle image error event
   */
  onImageError(): void {
    console.log('Giftcard preview image failed to load');
    this.errorMessage = 'Failed to load preview image';
    this.isLoading = false;
  }
}
